<ng-container [ngSwitch]="mode">
  <ng-container
    *ngSwitchCase="LabelMode.DEFAULT"
    [ngTemplateOutlet]="default"
  ></ng-container>
  <ng-container
    *ngSwitchCase="LabelMode.INLINE"
    [ngTemplateOutlet]="inline"
  ></ng-container>
  <ng-container
    *ngSwitchCase="LabelMode.NO_LABEL"
    [ngTemplateOutlet]="input"
  ></ng-container>
</ng-container>

<ng-template #input>
  <div
    class="daterange-wrapper d-flex flex-column flex-md-row  {{ inputClass }}"
    [formGroup]="form"
  >
    <div class="input-group" [ngClass]="{ disabled: form.disabled }">
      <input
        ngbDatepicker
        #d1="ngbDatepicker"
        [type]="clearable ? 'search' : 'text'"
        class="form-control"
        [placeholder]="'APP.START_DATE' | translate"
        formControlName="startValue"
        [firstDayOfWeek]="7"
        [minDate]="minPDate"
        [maxDate]="maxPDate"
        (click)="d1.toggle()"
      />
      <div class="input-group-append">
        <span class="input-group-text cursor-pointer" (click)="d1.toggle()">
          <app-keenicon
            name="calendar"
            class="fs-1 cursor-pointer"
          ></app-keenicon>
        </span>
      </div>
    </div>
    <!-- <nz-date-picker [nzFormat]="format" formControlName="startValue" [nzPlaceHolder]="'APP.START_DATE' | translate" [nzAllowClear]="false"></nz-date-picker> -->
    <div class="addon col-form-label fw-bold fs-6 py-2">
      {{ "APP.TO" | translate }}
    </div>
    <!-- <nz-date-picker [nzFormat]="format" formControlName="endValue" [nzPlaceHolder]="placeholder | translate" [nzAllowClear]="false"></nz-date-picker> -->
    <div class="input-group" [ngClass]="{ disabled: form.disabled }">
      <input
        ngbDatepicker
        #d2="ngbDatepicker"
        [type]="clearable ? 'search' : 'text'"
        class="form-control"
        [placeholder]="'APP.END_DATE' | translate"
        formControlName="endValue"
        [firstDayOfWeek]="7"
        [minDate]="minPDate"
        [maxDate]="maxPDate"
        (click)="d2.toggle()"
      />
      <div class="input-group-append">
        <span class="input-group-text cursor-pointer" (click)="d2.toggle()">
          <app-keenicon
            name="calendar"
            class="fs-1 cursor-pointer"
          ></app-keenicon>
        </span>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #default>
  <div class="form-group {{ classes }}">
    <label
      [for]="name"
      class="col-form-label fw-bold fs-6 py-2"
      [ngClass]="required ? 'required' : ''"
      >{{ label | translate }}</label
    >
    <ng-container [ngTemplateOutlet]="input"></ng-container>
  </div>
</ng-template>

<ng-template #inline>
  <div class="form-group form-group-inline {{ classes }}">
    <label
      [for]="name"
      class="col-form-label fw-bold fs-6 py-2"
      [ngClass]="required ? 'required' : ''"
      >{{ label | translate }}</label
    >
    <ng-container [ngTemplateOutlet]="input"></ng-container>
  </div>
</ng-template>
